"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var channel_layout_values_1 = require("@wix/wix-vod-constants/dist/app-settings/channel-layout-values");
exports.default = (_a = {},
    _a[channel_layout_values_1.CHANNEL_LAYOUT_VALUES.CLASSIC] = 'classic',
    _a[channel_layout_values_1.CHANNEL_LAYOUT_VALUES.STRIP] = 'strip',
    _a[channel_layout_values_1.CHANNEL_LAYOUT_VALUES.COMPACT] = 'compact',
    _a[channel_layout_values_1.CHANNEL_LAYOUT_VALUES.SLIDER_SMALL] = 'small_slider',
    _a[channel_layout_values_1.CHANNEL_LAYOUT_VALUES.SLIDER_BIG] = 'big_slider',
    _a[channel_layout_values_1.CHANNEL_LAYOUT_VALUES.GRID] = 'grid',
    _a);
//# sourceMappingURL=layouts-map.js.map